export class MatchReview {
  partId: number = 0;
  notSuitable: boolean = false;
  note: string = "";
}

export class MatchReviews {
  _id?: string = "";
  _rev?: string = "";
  composedID: string = "";
  manufacturerPartNumber: string = "";
  matches: MatchReview[] = [];
  type: string = "matchReviews";
}

export function normalizeMatchReviewIdentityPart(value: unknown): string {
  return String(value ?? "")
    .trim()
    .replace(/\s+/g, " ");
}

export function buildMatchReviewComposedId(
  partNumber: unknown,
  manufacturerPartNumberRaw: unknown,
  nameRaw: unknown
): string {
  const parts = [partNumber, manufacturerPartNumberRaw, nameRaw].map(
    normalizeMatchReviewIdentityPart
  );

  return parts.every((part) => part !== "") ? JSON.stringify(parts) : "";
}

export function isValidMatchReviewComposedId(value: unknown): boolean {
  const composedID = normalizeMatchReviewIdentityPart(value);
  if (composedID === "") {
    return false;
  }

  try {
    const parts = JSON.parse(composedID);
    return (
      Array.isArray(parts) &&
      parts.length === 3 &&
      parts.every(
        (part: unknown) =>
          typeof part === "string" &&
          normalizeMatchReviewIdentityPart(part) === part &&
          part !== ""
      ) &&
      JSON.stringify(parts) === composedID
    );
  } catch {
    return false;
  }
}
